export type RegistrationState = {
    loading: boolean;
    success: boolean;
    eulaLoading: boolean;
    eula: string;
    validationSuccess: boolean;
    validationloading: boolean;
    errorCode: string;
    message: string;
    email: string;
    organizationName: string | null;
    firstName?: string | null;
    lastName?: string | null;
    phone?: string | null;
    existingUser: boolean;
    inviteUserLoading: boolean;
    inviteUserSuccess: boolean;
    deleteUserLoading: boolean;
    deleteUserSuccess: boolean;
};

export const initialRegistrationState: RegistrationState = {
    eulaLoading: false,
    eula: '',
    loading: false,
    success: false,
    validationSuccess: false,
    validationloading: true,
    errorCode: '',
    message: '',
    email: '',
    organizationName: '',
    firstName: '',
    lastName: '',
    phone: '',
    existingUser: false,
    inviteUserLoading: false,
    inviteUserSuccess: false,
    deleteUserLoading: false,
    deleteUserSuccess: false,
};
